<template>
  <div class="vw-modal-window-wrapper" v-if="showed">
    <div class="vw vw-modal-window" :id="name">
      <div class="vw-modal-window-header">
        <div class="vw-modal-window-header-label font-bold-24px">
          {{ header }}
        </div>
      </div>
      <div class="vw-modal-window-content-wrapper font-regular-16px">
        <slot></slot>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "ModalWindow",
  props: {
    name: {
      type: String,
      required: true,
    },
    header: {
      type: String,
      required: true,
    },
  },
  data() {
    return {
      showed: false,
    };
  },
};
</script>

<style lang="scss" scoped>
.vw-modal-window-wrapper {
  position: fixed;
  top: 0px;
  left: 0px;
  display: flex;
  justify-content: center;
  width: 100%;
  height: 100%;
  background-color: #61616198;
  z-index: 2000;
}

.vw-modal-window {
  display: flex;
  flex-direction: column;
  align-self: center;
  background-color: #FFFFFF;
  border-radius: 8px;
  box-shadow: 0 14px 28px rgba(0, 0, 0, 0.25), 0 10px 10px rgba(0, 0, 0, 0.22);
  padding: 25px 30px;
}

.vw-modal-window-header {
    margin-bottom: 17px;
}
</style>